import React from 'react';
import { format } from 'date-fns';
import { ChatMessageBlockType, UniqueVisitor, User } from 'sb-lib/types';
import { ActiveVisitor, ChatMessage } from 'types';
import { SessionChatMessage } from '../SessionChatMessage';

interface SessionChatBotMessageProps {
  message: ChatMessage;
  nextMessage?: ChatMessage;
  visitor: ActiveVisitor | UniqueVisitor | null;
  members: User[];
  isChatCollapsed: boolean;
  tooltipTheme?: 'light' | 'dark';
}

export const SessionChatBotMessage: React.FC<SessionChatBotMessageProps> = ({
  message,
  nextMessage,
  visitor,
  members,
  isChatCollapsed,
  tooltipTheme,
}) => {
  let choice: string;
  if (
    message.content.blocks[1] &&
    message.content.blocks[1].type === ChatMessageBlockType.CHOICES &&
    !!message.content.blocks[1].choice
  ) {
    choice = message.content.blocks[1].choice;
  }
  return (
    <>
      {message.content.blocks[1] &&
        message.content.blocks[1].type === ChatMessageBlockType.EMAIL_INPUT &&
        !!message.content.blocks[1].emailInput && (
          <SessionChatMessage
            key="visitor-answer"
            message={{
              ...message,
              text: message.content.blocks[1].emailInput,
              sourceType: 'visitor',
              from: message.visitorId,
            }}
            nextMessage={nextMessage}
            visitor={visitor}
            members={members}
            isChatCollapsed={isChatCollapsed}
            tooltipTheme={tooltipTheme}
          />
        )}
      {message.content.blocks[1] &&
        message.content.blocks[1].type === ChatMessageBlockType.PHONE_INPUT &&
        !!message.content.blocks[1].phoneInput && (
          <SessionChatMessage
            key="visitor-answer"
            message={{
              ...message,
              text: message.content.blocks[1].phoneInput,
              sourceType: 'visitor',
              from: message.visitorId,
            }}
            nextMessage={nextMessage}
            visitor={visitor}
            members={members}
            isChatCollapsed={isChatCollapsed}
            tooltipTheme={tooltipTheme}
          />
        )}
      {message.content.blocks[1] &&
        message.content.blocks[1].type === ChatMessageBlockType.SHORT_INPUT &&
        !!message.content.blocks[1].shortInput && (
          <SessionChatMessage
            key="visitor-answer"
            message={{
              ...message,
              text: message.content.blocks[1].shortInput,
              sourceType: 'visitor',
              from: message.visitorId,
            }}
            nextMessage={nextMessage}
            visitor={visitor}
            members={members}
            isChatCollapsed={isChatCollapsed}
            tooltipTheme={tooltipTheme}
          />
        )}
      {message.content.blocks[1] &&
        message.content.blocks[1].type === ChatMessageBlockType.SCHEDULE &&
        !!message.content.blocks[1].calendarEventStartTime && (
          <SessionChatMessage
            key="visitor-answer"
            message={{
              ...message,
              text: `Meeting scheduled for: ${format(
                new Date(message.content.blocks[1].calendarEventStartTime),
                'PPPPpp',
              )}`,
              sourceType: 'visitor',
              from: message.visitorId,
            }}
            nextMessage={nextMessage}
            visitor={visitor}
            members={members}
            isChatCollapsed={isChatCollapsed}
            tooltipTheme={tooltipTheme}
          />
        )}
      {message.content.blocks[1] &&
        message.content.blocks[1].type === ChatMessageBlockType.CHOICES &&
        !!message.content.blocks[1].choice && (
          <SessionChatMessage
            key="visitor-answer"
            message={{
              ...message,
              text:
                message.content.blocks[1].options.find(o => o.value === choice)?.label ||
                message.content.blocks[1].choice,
              sourceType: 'visitor',
              from: message.visitorId,
            }}
            nextMessage={nextMessage}
            visitor={visitor}
            members={members}
            isChatCollapsed={isChatCollapsed}
            tooltipTheme={tooltipTheme}
          />
        )}
      <SessionChatMessage
        key="bot-question"
        message={message}
        nextMessage={nextMessage}
        visitor={visitor}
        members={members}
        isChatCollapsed={isChatCollapsed}
        tooltipTheme={tooltipTheme}
      />
    </>
  );
};
